import { createUseStyles } from 'react-jss';
import { CouponImageBase64 } from '../images/CouponImageBase64';

export const useStyles = createUseStyles({
  container: {
    marginTop: '-14px',
  },
  imagecontainer: {
    display: 'flex',
    paddingBottm: '3px',
  },
  couponlightbulb: {
    paddingRight: '2px',
    paddingTop: '2px',
  },
  couponimagecontainer: {
    height: '135px',
    width: 'auto',
  },
  couponimage: {
    backgroundImage: CouponImageBase64,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    height: '100%',
    width: '100%',
  },
  couponsubtitle: {
    fontWeight: '600',
    fontSize: '16px',
    paddingTop: '7px',
    paddingBottom: '7px',
  },
});
